/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, View } from 'react-native';
import { modalExperience } from './modalExperience.styles';

type Props = {
  title: string;
  helper?: string;
  divided?: boolean;
  children: React.ReactNode;
};

export function ModalFormSection({ title, helper, divided = false, children }: Props) {
  return (
    <View style={divided ? modalExperience.formSectionWithDivider : modalExperience.formSection}>
      <Text style={modalExperience.formSectionTitle}>{title}</Text>
      {helper ? <Text style={modalExperience.formSectionHelper}>{helper}</Text> : null}
      {children}
    </View>
  );
}
